// extracted by mini-css-extract-plugin
export var modal = "_dw-0";